(function () {
const deliveryFaqModal = document.querySelector('.delivery-faq-modal')
const deliveryFaqButton = document.querySelector(
  '#delivery-faq-button'
)
const deliveryFaqClose = document.querySelector('#delivery-faq-modal--close')

deliveryFaqButton?.addEventListener('click', () => {
  deliveryFaqModal?.classList.toggle('show')
})
deliveryFaqClose?.addEventListener('click', () => {
  deliveryFaqModal?.classList.remove('show')
})

this.addEventListener('keydown', (event) => {
  if (event.code.toUpperCase() === 'ESCAPE')
  deliveryFaqModal?.classList.remove('show')
})

const bookDemoModal = document.querySelector('.book-demo-modal')
const bookDemoButton = document.querySelector('#book-demo-button')
const bookDemoClose = document.querySelector('#book-demo-modal--close')

if (bookDemoButton && bookDemoModal && bookDemoClose) {
  let locksScroll = false
  const closeBookDemo = () => {
    if (!bookDemoModal.classList.contains('show')) return
    bookDemoModal.classList.remove('show')
    bookDemoModal.inert = true
    bookDemoModal.setAttribute('aria-hidden', 'true')
    bookDemoButton.setAttribute('aria-expanded', 'false')
    if (locksScroll) document.body.classList.remove('overflow-hidden')
    locksScroll = false
    removeTrapFocus(bookDemoButton)
  }

  bookDemoButton.addEventListener('click', () => {
    if (bookDemoModal.classList.contains('show')) return
    bookDemoModal.inert = false
    bookDemoModal.setAttribute('aria-hidden', 'false')
    bookDemoModal.classList.add('show')
    bookDemoButton.setAttribute('aria-expanded', 'true')
    locksScroll = !document.body.classList.contains('overflow-hidden')
    document.body.classList.add('overflow-hidden')
    trapFocus(bookDemoModal, bookDemoClose)
  })
  bookDemoClose.addEventListener('click', closeBookDemo)
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeBookDemo()
  })
}

// The Academy controller handles focus and section replacement for the same modal.
const sizeChartModal = document.querySelector('.size-chart-modal:not([data-academy-size-dialog]):not([data-academy-comparison-dialog]):not([data-book-demo-dialog])');
const sizeChartButton = document.querySelector('#size-chart-button');
const sizeChartClose  = document.querySelector('#size-chart-modal--close');

if (sizeChartButton && sizeChartModal && sizeChartClose) {
  let restoreBackground;
  let locksScroll = false;
  const close = () => {
    if (!sizeChartModal.classList.contains('show')) return;
    sizeChartModal.classList.remove('show');
    restoreBackground?.();
    restoreBackground = null;
    if (locksScroll) document.body.classList.remove('overflow-hidden');
    removeTrapFocus(sizeChartButton);
    sizeChartModal.inert = true;
    sizeChartModal.setAttribute('aria-hidden', 'true');
  };
  sizeChartButton.addEventListener('click', () => {
    if (sizeChartModal.classList.contains('show')) return;
    sizeChartModal.inert = false;
    sizeChartModal.removeAttribute('aria-hidden');
    sizeChartModal.classList.add('show');
    locksScroll = !document.body.classList.contains('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    restoreBackground = inertOutside(sizeChartModal);
    trapFocus(sizeChartModal, sizeChartClose);
  });
  sizeChartClose.addEventListener('click', close);
  sizeChartModal.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
  });
}

const pdpVideoPlay = document.querySelector('#pdp-video-play')
const pdpVideoElement = document.querySelector('#pdp-video-element')

if (pdpVideoPlay && pdpVideoElement) {
  pdpVideoPlay.addEventListener('click', () => {
    pdpVideoElement.play();
    pdpVideoPlay.classList.add('hide-button');
  })

  pdpVideoElement.addEventListener("ended", (event) => {
    pdpVideoPlay.classList.remove('hide-button');
  });
}

const showHideFixedAddToCart = () => {

  const fixedAddCart = document.querySelector('.mobile-add-cart-btn');
  const standardAddCart = document.querySelector('.default-add-cart-btn');
  if (!fixedAddCart || !standardAddCart || standardAddCart.closest('[data-academy-product]')) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        fixedAddCart.classList.add('hide-btn');
      } else {
        fixedAddCart.classList.remove('hide-btn');
      }
    });
  });

  if (window.innerWidth < 751) {
    observer.observe(standardAddCart);
  } else {
    observer.unobserve(standardAddCart);
  }

}

showHideFixedAddToCart();

// Apply padding-right to the last media item based on #product-information width (desktop only)
(() => {
  // Adjust to your theme's desktop breakpoint
  const mql = window.matchMedia('(min-width: 990px)');

  const getInfo = () => document.getElementById('product-information');
  const getMediaList = () => document.querySelector('.product__media-list');
  const getLastItem = () =>
    document.querySelector('.product__media-list .product__media-item:last-of-type') ||
    document.querySelector('.product__media-list .product__media-item:last-child');

  let active = false;
  let scheduled = false;
  let ro = null; // ResizeObserver
  let mo = null; // MutationObserver

  const sectionEvents = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:select', 'shopify:section:deselect'];
  const onResize = () => scheduleApply();
  const onOrientation = () => scheduleApply();
  const onSection = () => { scheduleApply(); wireObservers(); };

  const scheduleApply = () => {
    if (!active) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const apply = () => {
    if (!active) return;
    const info = getInfo();
    const target = getLastItem();
    if (!info || !target) return;

    const width = Math.round(info.getBoundingClientRect().width || info.offsetWidth || 0);
    target.style.paddingRight = width ? `${width}px` : '';
  };

  const wireObservers = () => {
    if (!active) return;

    // Disconnect any previous observers
    if (ro) { ro.disconnect(); ro = null; }
    if (mo) { mo.disconnect(); mo = null; }

    const info = getInfo();
    if (info && 'ResizeObserver' in window) {
      ro = new ResizeObserver(() => scheduleApply());
      ro.observe(info);

      // If images inside product info load later, they can affect width
      info.querySelectorAll('img').forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', scheduleApply, { once: true });
          img.addEventListener('error', scheduleApply, { once: true });
        }
      });
    }

    const list = getMediaList();
    if (list && 'MutationObserver' in window) {
      mo = new MutationObserver(() => scheduleApply());
      mo.observe(list, { childList: true });
    }
  };

  const start = () => {
    if (active) return;
    active = true;

    // Initial apply once DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
    } else {
      scheduleApply();
    }
    window.addEventListener('load', scheduleApply);
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onOrientation);
    sectionEvents.forEach(evt => window.addEventListener(evt, onSection));

    wireObservers();
  };

  const stop = () => {
    if (!active) return;
    active = false;

    // Tear down observers/listeners
    if (ro) { ro.disconnect(); ro = null; }
    if (mo) { mo.disconnect(); mo = null; }

    window.removeEventListener('load', scheduleApply);
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onOrientation);
    sectionEvents.forEach(evt => window.removeEventListener(evt, onSection));

    // Clear any inline padding that was set for desktop
    const target = getLastItem();
    if (target) target.style.paddingRight = '';
  };

  // Respond to breakpoint changes
  const handleMql = e => {
    if (e.matches) start();
    else stop();
  };

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', handleMql);
  } else if (typeof mql.addListener === 'function') {
    // Safari fallback
    mql.addListener(handleMql);
  }

  // Initial state
  if (mql.matches) start();
  else stop();
})();


// Might use later for PDP product image on desktop

// $(function() {
//   var maxL = 5;
//   //set you number to show
//   var listItems = jQuery('.product__media-list li').length;
//   // get curent number of items
//   if (listItems > maxL) {
//     // if curent number is biger then wanted
//     $('.product__media-list li:nth-child(+n+' + (maxL + 1) + ')').addClass("hide-content")
//     //find all li items after set crop number
//     $('<li><span class="dots">...CLICK</span></li>').insertAfter($('.product__media-list li:last-child'));
//     //add span with dots or whatever
//   }

// });


// $(document).on("click", ".dots", function() {
//   // on click of dots remove hidden class and remove dots parent li element
//   $('.product__media-list').find(".hide-content").removeClass("hide-content")
//   $('.product__media-list').find(".dots").parent("li").remove()
// });

})();
